export const getQueryParam = (param) => {
  const rx = new RegExp(`[?&]${param}=([^&]+).*$`);
  var returnVal = window.location.search.match(rx);
  if (returnVal) {
    return decodeURIComponent(returnVal[1].replace(/\+/g, ' '));
  }
}